import { API_BASE_URL } from "../../constants/index";
import HttpInterface from "../../helpers/HttpInterface";

export class OrdersService {
  private httpProxy: HttpInterface;
  constructor() {
    this.httpProxy = new HttpInterface();
  }

  reject(id: string, motivation: string): Promise<string> {
    const requestOptions = {
      method: "POST",
      body: motivation,
    };

    return this.httpProxy.fetch(
      `${API_BASE_URL}/logistic-service/orders/${id}/reject`,
      requestOptions,
      { "Content-Type": "text/plain", Accept: "text/plain" }
    );
  }
}
